import { Menu as MantineMenu } from "@mantine/core";
import { Button } from "./Button";
import { STRINGS } from "./strings";

/* The actions on a row, behind one button that opens a list.
 *
 * The same control on a wide screen and a phone, because touch has no hover
 * and the actions a rep takes between calls have to be reachable without
 * opening the record. docs/design-standards.md, One interface, every screen
 * size. */
export type MenuItem = {
  label: string;
  onSelect: () => void;
  /** Said on hover and to a screen reader, when the label alone is terse. */
  title?: string;
  /** For Remove and Archive and anything else that should not be pressed by accident. */
  danger?: boolean;
};

export function RowMenu({ label = STRINGS.actions, items }: { label?: string; items: readonly MenuItem[] }) {
  return (
    /* The row opens a record on click, and a click anywhere in this menu must
       not. React events bubble through the dropdown's portal to the row, so
       the stop is on a wrapper around the whole menu rather than on the
       button alone. */
    <span className="ui-row-menu" onClick={(e) => e.stopPropagation()}>
      <MantineMenu position="bottom-end" withinPortal>
        <MantineMenu.Target>
          <Button size="compact-sm" className="ui-row-menu-button" aria-haspopup="menu">
            {label}
            <span className="ui-caret" aria-hidden="true">▾</span>
          </Button>
        </MantineMenu.Target>
        <MantineMenu.Dropdown>
          {items.map((item) => (
            <MantineMenu.Item
              key={item.label}
              onClick={item.onSelect}
              title={item.title ?? ""}
              className={item.danger ? "ui-menu-item-danger" : "ui-menu-item"}
            >
              {item.label}
            </MantineMenu.Item>
          ))}
        </MantineMenu.Dropdown>
      </MantineMenu>
    </span>
  );
}
